export default (value) => {
    let formattedValue = parseFloat(value).toFixed(1);
    formattedValue = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(formattedValue);
    return formattedValue;
  }